export const formatColorStr = (str: string) => {
    const char = str.charAt(0);
    const charUpper = str.charAt(0).toLocaleUpperCase();
    const x = str.replace(char, charUpper);
    return stripDash(x);
};
export const stripDash = (str: string) => {
    let y = '';
    let z = str;
    if (str.includes('-')) {
        const index = str.indexOf('-') + 1;
        y = str.replace(
            str.charAt(index),
            str.charAt(index).toLocaleUpperCase()
        );
        z = y.replace(/-/g, '_');
    }
    return z;
};
